import ApiClient from './ApiClient';

class CrmDealFinalStagesAPI extends ApiClient {
  constructor() {
    super('crm_deal_final_stages', { accountScoped: true });
  }

  get(params = {}) {
    return axios.get(this.url, { params });
  }
}

export default new CrmDealFinalStagesAPI();
